import { Pipe, PipeTransform } from '@angular/core';
import { AcademicTitles } from '../dtos/AcademicTitle';

@Pipe({
    name: 'academicTitle',
    standalone: true
})
export class AcademicTitlePipe implements PipeTransform {

  transform(value: string | undefined): string | null {

    if (value === undefined || value === null) {
      return null;
    }

    for (let i = 0; i < AcademicTitles.length; i++) {
      if (AcademicTitles[i].value === value) {
        return AcademicTitles[i].label;
      }
    }
    return null;
  }

}
